export default __webpack_public_path__ + "static/media/regalo-agregado.bd1abf02.svg";